module.exports = __webpack_public_path__ + "img/IMG_8618_L_WoodMatted_MockedUp.f8ec01e1.jpg";